/**
 * @module interface
 */
export interface V2TimCallback {
    code: number;
    desc: string;
}
